module.exports = __webpack_public_path__ + "static/img/teams.ade5181f.png";